import React,{useState,useEffect} from 'react';
import './personal-details.css'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {selectCurrentUser} from '../../redux/user/user.selectors'
import { toast } from "react-toastify";
import {firestore ,auth} from '../../components/firebase/firebase.utils'
import firebase from '../firebase/firebase.utils';
const PersnolDetails=(currentUser)=>{
   
    const [userdata,setUserdata]=useState([])
   
    
      
    
    
       
            useEffect(() => {
                const fetchData=async()=>{
                    if(auth.currentUser){
                    const userAuth =auth.currentUser;
                    const userProductRef = firestore.collection(`users/${firebase.auth().currentUser.uid}/soldProducts`)
                    await userProductRef.get().then(function(querySnapshot){
                        querySnapshot.docs.map(function(doc) {
                           console.log(doc.data())
                          });
                    });
                
                        const snapShot =await firestore.doc(`users/${userAuth.uid}`).get();
                    setUserdata(snapShot.data())
                    }
                };
                fetchData();
              }, [userdata])
            
        return(
           <div className="parent" >

                  <div className="cont-left" >
                      <img src="https://image.flaticon.com/icons/png/512/1077/1077114.png" className="img" style={{}}></img>
                  </div>
                  <div className="cont-right" >
                    <div className="details" ><h1>{userdata.displayName}</h1></div>
                    <div className="details" ><h1>{userdata.email}</h1></div>
                    <div className="details" ><h1>{userdata.phone}</h1></div>
                    
                 </div>    


            </div>
           
        );
        
    
}

const mapStateToProps = createStructuredSelector({
    currentUser: selectCurrentUser
    
  });
export default connect(mapStateToProps)(PersnolDetails);